var map = {
	"./articles-1.jpg": 57555,
	"./articles-2.jpg": 63537,
	"./articles-3.jpg": 46501,
	"./articles-4.jpg": 59876,
	"./patient-20.jpg": 19239,
	"./patient-21.jpg": 13251,
	"./patient.jpg": 64825,
	"./patient1.jpg": 65266,
	"./patient10.jpg": 52956,
	"./patient11.jpg": 72817,
	"./patient12.jpg": 37860,
	"./patient13.jpg": 87834,
	"./patient14.jpg": 3438,
	"./patient15.jpg": 42416,
	"./patient16.jpg": 30671,
	"./patient17.jpg": 45601,
	"./patient18.jpg": 61434,
	"./patient19.jpg": 93294,
	"./patient2.jpg": 80518,
	"./patient3.jpg": 2594,
	"./patient4.jpg": 90256,
	"./patient5.jpg": 91619,
	"./patient6.jpg": 12163,
	"./patient7.jpg": 5151,
	"./patient8.jpg": 41487,
	"./patient9.jpg": 12365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 605;